export default class FormError extends Error {
    constructor(message, form) {
      super(message); // Call the parent constructor with the message
      this.name = this.constructor.name; // Set the error name to the class name
      this.form = form; // Custom property
    }
  }